import { registerPlugin } from '@capacitor/core';
import type { PluginListenerHandle } from '@capacitor/core';

export interface HmsPushPlugin {
  getPushProvider(): Promise<{ provider: 'FCM' | 'HMS' }>;
  register(): Promise<{ token: string | null }>;
  setSuppressMessengerBanners(options: { suppress: boolean }): Promise<void>;
  addListener(eventName: 'tokenRefresh', listenerFunc: (event: { token: string }) => void): Promise<PluginListenerHandle>;
  addListener(
    eventName: 'notificationOpened',
    listenerFunc: (event: { data: Record<string, string> }) => void
  ): Promise<PluginListenerHandle>;
  addListener(
    eventName: 'messengerReadSync',
    listenerFunc: (event: { chatId: string | number }) => void
  ): Promise<PluginListenerHandle>;
}

export const HmsPush = registerPlugin<HmsPushPlugin>('HmsPush');
